// import 'babel-polyfill'
import Vue from 'vue'
import App from './App'

// // 添加Fastclick移除移动端点击延迟
// import FastClick from 'fastclick'
// FastClick.attach(document.body)

// 添加手势触摸事件，使用方法如 v-touch:swipeleft
import VueTouch from './plugins/touchEvent'
Vue.use(VueTouch)

// import VueRecyclerviewNew from 'vue-recyclerview'
// Vue.use(VueRecyclerviewNew)

// 同步单页路由与数据中心
import store from './store'
import router from './router'
import tlstore from './store/tlconfig'
import cookie from './utils/cookie'
new Vue({
  router,
  store,
  tlstore,
  mounted () {
  		var user={};
  		user.ticket=cookie.readCookie('ticket')
  		user.uid=cookie.readCookie('userid')
      // var temp=tlstore.commit('hasLogin');
      // alert(cookie.readCookie('ticket'))
      // cookie.delCookie('canLogin');
      // alert(cookie.readCookie('canLogin')+':'+cookie.readCookie('sdktoken'))
      if(cookie.readCookie('canLogin')){
        tlstore.commit('init',user);
      }
  	},
  render: h => h(App),
}).$mount('#app')

function GetQueryString(name)
{
 var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
 var r = window.location.search.substr(1).match(reg);
 if(r!=null)return  unescape(r[2]); return null;
}



// WEBPACK FOOTER //
// ./src/main.js